'use strict'


var _ = require('lodash')
var Marionette = require('marionette')

var App = require('app')

var EditNewController = require('src/components/edit_new-controller.js')

var RoutineComposer = require('src/components/routine-composer')
var DialogModel = require('src/common/dialog-model.js')
var Helpers = require('src/common/helpers')

/* Views */
var View = require('./view.js')

var DeviceControl = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      console.log(options)
      var self = this
      this.region = options.region

      var clients = App.globalChannel.request('client:entities:cached')
      var device = options.device
      var devices = options.collection

      var group = options.group

      if (group) {
        self.deviceType = group.get('type')
        var client = clients.get(group.get('client'))
      } else if (device) {
        self.deviceType = device.get('type')
        var client = clients.get(device.get('client'))
      }



      self.device = device
      self.client = client

      // Dialog Model
      //
      var dialogModel = new DialogModel({
        title: 'Set register',
        automaticTitle: false, // detects wheter the model is new or edit
        
        buttons: {
          left: [
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        }
      })

    

      //
      this.view = this.getView(dialogModel, device, client, options.register)

      // this.listenTo(this.view, 'render', function (view) {
      //   self.bodyRegion(device, client, self.deviceType)
      // })

      this.listenTo(this.view, 'dialog:save-preset', this.onSavePreset)
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)

      this.region.show(this.view)
    },
    formSubmit: function (view) {
      var self = this
      var model = view.model
      var data = Backbone.Syphon.serialize(view)
      let registerValue = parseInt(data.register_value)

      model.setRegister(self.options.register.key, registerValue)
      // console.log(data)
      // console.log(this.options)

      // // when radius or duration isn't set
      // if (!data.radius) {
      //   console.log(data.radius)
      //   App.dialog.alert('Could not activate emergency mode, radius or duration missing')
      // }

      // //
      // // var emergencyOptions = {
      // //   'location': model.get('location'),
      // //   'radius': data.radius,
      // //   'duration': data.duration,
      // //   'enable': 1
      // // }

      // model.set()

      // // simple user notification if it takes longer than expected
      // var notifyUser = function () {
      //   App.dialog.alert('Activating emergency mode...')
      // }
      // var notifyUserTimer = setTimeout(() => notifyUser(), 300)

      // model.save({
      //   'radius': data.radius,
      //   'duration': data.duration,
      //   'enable': 1
      // }, {
      //   error: function (model, response) {
      //     clearTimeout(notifyUserTimer)
      //     return App.dialog.alert(response.responseJSON.message)
      //   },
      //   success: function (model, response) {
      //     clearTimeout(notifyUserTimer)
      //     App.dialog.alert('Emergency mode activated on ' + response.nrOfTargetedDevices + ' devices')
      //   }
      // })

      self.region.empty()
    },
    /**
     *
     */

    // prepare the bulk data to be saved
    formBulkPreSave: function (model, collection, data) {
      let routines = this.parseRoutines()
      let payload = {}
      payload.defaultSchedule = routines

      return payload
    },


    onSendCommand: function (data) {
      var self = this

      if (self.options.bulkAction) {
        let bulkCollection = self.view.collection
        return bulkCollection.sendBulkCommand(data)
      }

      if (self.options.group) {
        let group = self.options.group
        return group.sendCommand(data)
      }

      let device = self.device
      device.sendCommand(data, {
        success:(value) => {
          App.dialog.notice(App.TextParser('NOTICE_COMMAND_SENT'))
        }
      })
    },
    getView: function (dialogModel, device, client, register) {
      return new View.Layout({
        dialogModel: dialogModel,
        model: device,
        client: client,
        register: register
      })
    }

  })

  return new Controller(options)
}

module.exports = DeviceControl



// WEBPACK FOOTER //
// ./js/modules/devices/register/index.js